export const makeApiUrl = (path: String): string =>
  `https://api.precificador.autoblue.com.br${path}`;
